// Vue
import { Component, Prop, Provide, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { HttpService } from "../../../services/HttpService";
import { IRegion } from "../../../interfaces/IRegion";
import { ILanguage } from "../../../interfaces/ILanguage";
import { HeaderDefault } from "../header_default/HeaderDefault";
import { Footer } from "../footer/Footer";
import { getCookie } from "../../../utils/cookie";

@Component({
  mixins: [template],
  components: {
    HeaderDefault,
    Footer,
  },
})
export class HeaderFooterApplication extends Vue {
  private readonly http: HttpService = HttpService.instance;

  public headerRegions: IRegion[] = [];

  @Provide("marketingCookies")
  public marketingCookies: string[] = [];

  @Prop()
  public appId!: string;

  @Prop()
  public language!: string;

  @Prop()
  public country!: string;

  @Prop({
    default: () => {
      return window.location.origin;
    },
  })
  public redirectUrlAfterLogout!: string;

  @Prop({
    default: () => {
      return window.location.origin;
    },
  })
  public homeLink!: string;

  @Prop({
    default: () => {
      return [];
    },
  })
  public supportedLanguages!: ILanguage[];

  @Prop({ default: false })
  public willProvideRegions!: boolean;

  @Prop({
    default: () => {
      return [];
    },
  })
  public supportedRegions!: IRegion[];

  @Prop({ default: false })
  public disableAuth!: boolean;

  @Prop({ default: null })
  public options!: object | null;

  @Prop({ default: false })
  public enableFavorites!: boolean;

  @Prop({ default: false })
  public enableVehicleConfigs!: boolean;

  @Prop({ default: true })
  public withCookieLayer!: boolean;

  private appInfo: any = null;

  get anbieterUrl() {
    if (this.appInfo) {
      return this.appInfo["anbieter_url"];
    } else {
      return null;
    }
  }

  get rechtlicheHinweiseUrl() {
    if (this.appInfo) {
      return this.appInfo["rechtliche_hinweise_url"];
    } else {
      return null;
    }
  }

  get cookiesUrl() {
    if (this.appInfo) {
      return this.appInfo["cookies_url"];
    } else {
      return null;
    }
  }

  get datenschutzUrl() {
    if (this.appInfo) {
      return this.appInfo["datenschutz_url"];
    } else {
      return null;
    }
  }

  get lizenzhinweiseDritterUrl() {
    if (this.appInfo) {
      return this.appInfo["lizenzhinweise_dritter_url"];
    } else {
      return null;
    }
  }

  get copyrightText() {
    if (this.appInfo) {
      return this.appInfo["footer_text"];
    } else {
      return null;
    }
  }

  public created() {
    this.getApplikationInfo();

    this.marketingCookies = getCookie("marketing-cookies") ? JSON.parse(getCookie("marketing-cookies")) : [];

    window.document.addEventListener("onCookiesAccepted", this.onCookiesAccepted, false);
  }

  public async getApplikationInfo() {
    if (this.appId) {
      let url = `/api/identity/v1.0/${this.language}/applikation/${this.appId}/disclaimer`;
      let response = await this.http.get<any[]>(url);

      this.appInfo = response.body!;
    }
  }

  @Provide("CI2019HandleFooterClick")
  public handleFooterClick(itemName) {
    // @ts-ignore
    this.$refs["Header"].openPolicy(itemName);
  }

  onCookiesAccepted(event: CustomEventInit<string>) {
    if (event.detail === "onCookiesAccepted") {
      // @ts-ignore
      this.$refs["Header"].closePolicy();

      this.marketingCookies = getCookie("marketing-cookies") ? JSON.parse(getCookie("marketing-cookies")) : [];
    }
  }
}
